const size = {
  mobile: '500px',
  tablet: '900px',
  large: '1120px',
};

const devices = {
  mobile: `(max-width: ${size.mobile})`,
  tablet: `(max-width: ${size.tablet})`,
  large: `(max-width: ${size.large})`,
};

export default devices;